import { Col, Form, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { isinGetNaceList } from 'services/akcionar/emise/zadostISIN';
import { updateEmitentData } from 'services/dokumenty/dodatek';
import { ISmlouvniStrany, dokumentSmlouvniStranyGet } from 'services/dokumenty/smlouva';

import { EPodTypDokumentu } from 'enums/dokumentyEnums';
import { naceRegExp } from 'enums/regExp';

import dicValidation from 'utils/validations/dicValidation';
import icoNidValidation from 'utils/validations/icoNidValidation';
import leiValidation from 'utils/validations/leiValidation';

import { getCountryText } from '../Lei/formularPages/PrehledPages/DetailInfoPrehled';

interface IIdentifikaceStran {
    nextStep: () => void;
    zadostID: number;
    signingDisabled: boolean;
}

const IdentifikaceStran: React.FC<IIdentifikaceStran> = ({ nextStep, zadostID, signingDisabled }) => {
    const [formCDCP] = Form.useForm();
    const [form] = Form.useForm();
    const { language, dokumenty, cisStaty } = useContext(Context);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<ISmlouvniStrany>();
    const [naceData, setNaceData] = useState<{ labelcz: string; value: string }[]>();

    useEffect(() => {
        setLoading(true);
        isinGetNaceList().then(
            resp =>
                resp.nacelist.length &&
                setNaceData(
                    resp.nacelist.map(e => {
                        return {
                            labelcz: e.nacepopis,
                            value: e.nace
                        };
                    })
                )
        );
        dokumentSmlouvniStranyGet(zadostID)
            .then(resp => setData(resp))
            .finally(() => setLoading(false));
    }, [zadostID]);

    return (
        <LoadingWrapper loading={loading}>
            {data && (
                <>
                    <FormWrapper outForm={formCDCP} onFinish={() => {}} displayOnly={true}>
                        <Title text="DOKMUNET_IDENTIFIKACE_SUBTITLE" level={5} />
                        <Title text="DOKMUNET_IDENTIFIKACE_CDCP" level={5} dividerTitle={true} />
                        <InputComponent
                            disabled={true}
                            initialValue={data?.cdcp.idmb}
                            label="IDENTIFIKACNI_CISLO"
                            name="idmb2"
                            notRequired={true}
                        />
                        {data?.cdcp.dicdph && (
                            <InputComponent
                                disabled={true}
                                initialValue={data?.cdcp.dicdph}
                                label="ISIN_IDENTIFIKACE_DIC"
                                name="dicdph2"
                                notRequired={true}
                            />
                        )}
                        <InputComponent
                            disabled={true}
                            initialValue={data?.cdcp.nazev}
                            label="ISIN_IDENTIFIKACE_FIRMA"
                            name="nazev2"
                            notRequired={true}
                        />
                        <InputComponent
                            disabled={true}
                            initialValue={data?.cdcp.lei}
                            label="LEI_CELE"
                            name="lei2"
                            notRequired={true}
                        />
                        <InputComponent
                            label="LEI_DETAIL_ADRESA_TITLE"
                            name="adma2"
                            initialValue={`${data?.cdcp.adma}, ${data?.cdcp.mema}, ${data?.cdcp.pscm}, ${getCountryText(
                                data?.cdcp.kost || '',
                                language
                            )}`}
                            notRequired={true}
                            disabled={true}
                        />{' '}
                        <InputComponent
                            label="BANKOVNI_UCET"
                            name="bankucet2"
                            // eslint-disable-next-line max-len
                            initialValue={`${data?.cdcp.predcisli ? data?.cdcp.predcisli + '-' : ''}${data?.cdcp.cislouctu + '/'}${data?.cdcp.banka}`}
                            notRequired={true}
                            disabled={true}
                        />
                    </FormWrapper>
                    {/* <Title level={5} text={'LEI_DETAIL_ADRESA_TITLE'} />
                    
                    <InputComponent
                        label="ULICE_CP"
                        name="adma"
                        initialValue={data?.cdcp.adma}
                        notRequired={true}
                        disabled={true}
                    />
                    <InputComponent
                        label="MESTO"
                        name="mema"
                        initialValue={data?.cdcp.mema}
                        notRequired={true}
                        disabled={true}
                    />
                    <InputComponent
                        label="PSC"
                        name="pscm"
                        initialValue={data?.cdcp.pscm}
                        usePscFormater={form.getFieldValue('stat') === 'SK' || form.getFieldValue('stat') === 'CZ'}
                        notRequired={true}
                        disabled={true}
                    />
                    <SelectComponent
                        notRequired={true}
                        disabled={true}
                        name="kost"
                        labelParagraph="STAT_SIDLA"
                        isFormItem={true}
                        data={cisStaty}
                        defaultValue={data?.cdcp.kost}
                    />*/}

                    <FormWrapper
                        outForm={form}
                        onFinish={val => {
                            setLoading(true);
                            updateEmitentData(zadostID, {
                                ...(val as any)
                            })
                                .then(() => nextStep())
                                .finally(() => setLoading(false));
                        }}
                    >
                        <Title level={5} text={'EMITENT'} dividerTitle={true} />
                        <InputComponent
                            initialValue={data?.spolecnost.idmb}
                            label="IDENTIFIKACNI_CISLO"
                            name="idmb"
                            maxLength={30}
                            rules={signingDisabled || !!data?.spolecnost.idmb ? undefined : icoNidValidation('kost')}
                            disabled={signingDisabled || !!data?.spolecnost.idmb}
                        />
                        <InputComponent
                            initialValue={data?.spolecnost.dicdph}
                            label="ISIN_IDENTIFIKACE_DIC"
                            name="dicdph"
                            maxLength={14}
                            rules={dicValidation()}
                            notRequired={true}
                            disabled={signingDisabled}
                        />
                        <InputComponent
                            initialValue={data?.spolecnost.nazev}
                            label="ISIN_IDENTIFIKACE_FIRMA"
                            name="nazev"
                            disabled={signingDisabled}
                        />
                        <InputComponent
                            initialValue={data?.spolecnost.lei}
                            label="LEI_CELE"
                            name="lei"
                            maxLength={20}
                            rules={leiValidation()}
                            disabled={signingDisabled}
                        />
                        <InputComponent
                            label="ULICE_CP"
                            name="adma"
                            initialValue={data?.spolecnost?.adma}
                            type="text"
                            maxLength={50}
                            disabled={signingDisabled}
                        />
                        <InputComponent
                            label="MESTO"
                            name="mema"
                            initialValue={data?.spolecnost?.mema}
                            type="text"
                            maxLength={50}
                            disabled={signingDisabled}
                        />
                        <InputComponent
                            label="PSC"
                            name="pscm"
                            initialValue={data?.spolecnost?.pscm}
                            maxLength={10}
                            type="text"
                            disabled={signingDisabled}
                        />
                        <SelectComponent
                            name="kost"
                            labelParagraph="STAT_SIDLA"
                            isFormItem={true}
                            defaultValue={data?.spolecnost?.kost}
                            data={cisStaty}
                            disabled={signingDisabled || !!data?.spolecnost?.kost}
                        />
                        <Title level={5} text={'DOPLNUJICI_INFORMACE'} />
                        {naceData ? (
                            <SelectComponent
                                isFormItem={true}
                                name="nace"
                                defaultValue={data?.spolecnost?.nace}
                                labelParagraph="NACE"
                                data={naceData.map(e => {
                                    return {
                                        value: e.value,
                                        labelcz: e.value + ' - ' + e.labelcz
                                    };
                                })}
                                disabled={signingDisabled}
                            />
                        ) : (
                            <InputComponent
                                label="CZ_NACE"
                                infoTooltipText="FORMULARE_NACE_TOOLTIP"
                                maxLength={17}
                                name="nace"
                                initialValue={data?.spolecnost?.nace}
                                disabled={signingDisabled}
                                rules={[
                                    () => ({
                                        validator(_, value: string) {
                                            if (!value || naceRegExp.test(value)) return Promise.resolve();
                                            return Promise.reject(<TranslateText>NEVALIDNI_NACE</TranslateText>);
                                        }
                                    })
                                ]}
                            />
                        )}
                        {/* <InputComponent
                            label="ISIN_IDENTIFIKACE_ADRESA_SIDLA"
                            name="adma"
                            // eslint-disable-next-line max-len
                            initialValue={`${data?.spolecnost.adma}, ${data?.spolecnost.mema}, ${data?.spolecnost.pscm}, ${getCountryText(
                                data?.cdcp.kost || '',
                                language
                            )}`}
                        />
                        <Title level={5} text={'ISIN_IDENTIFIKACE_ADRESA_SIDLA'} />

                    <InputComponent
                        label="ULICE_CP"
                        name="adma"
                        initialValue={data?.spolecnost.adma}
                        notRequired={true}
                        disabled={true}
                    />
                    <InputComponent
                        label="MESTO"
                        name="mema"
                        initialValue={data?.spolecnost.mema}
                        notRequired={true}
                        disabled={true}
                    />
                    <InputComponent
                        label="PSC"
                        name="pscm"
                        initialValue={data?.spolecnost.pscm}
                        usePscFormater={form.getFieldValue('stat') === 'SK' || form.getFieldValue('stat') === 'CZ'}
                        notRequired={true}
                        disabled={true}
                    />
                    <SelectComponent
                        notRequired={true}
                        disabled={true}
                        name="kost"
                        labelParagraph="STAT_SIDLA"
                        isFormItem={true}
                        data={cisStaty}
                        defaultValue={data?.spolecnost.kost}
                    />*/}

                        <Paragraph
                            text={
                                dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.SMLOUVA
                                    ? 'DOKUMNETY_SMLOUVA_IDENTIFIKACE_TEXT'
                                    : dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.SMLOUVADLT
                                      ? 'DOKUMNETY_SMLOUVA_IDENTIFIKACE_DLT_TEXT'
                                      : dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.DODATEK
                                        ? 'DOKUMNETY_DODATEK_IDENTIFIKACE_TEXT'
                                        : dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.DODATEKDLT
                                          ? 'DOKUMNETY_DODATEKDLT_IDENTIFIKACE_TEXT'
                                          : ''
                            }
                            style={{
                                display: 'block',
                                marginTop: 10,
                                marginBottom: 10
                            }}
                        />
                    </FormWrapper>
                    <Row>
                        <Col>
                            {/* <ButtonComponent buttontext="ZPET" onClick={() => prevSte} id="isinPokracovatBtn" /> */}
                            <ButtonComponent
                                buttontext="POKRACOVAT"
                                onClick={() => form.submit()}
                                id="isinPokracovatBtn"
                            />
                        </Col>
                    </Row>
                </>
            )}
        </LoadingWrapper>
    );
};

export default IdentifikaceStran;
